import request from "axios";
/** 分页查询合伙人接口 */
export const getPartnerList = (params) => {
  return request({
    url: "/lebo-member/web/partner/manage/list",
    method: "get",
    params
  });
};
/** 新增合伙人接口 */
export const addPartner = (data) => {
  return request({
    url: "/lebo-member/web/partner/manage/save",
    method: "post",
    data
  });
}
/** 导出合伙人excel */
export const exportPartner = (params) => {
  return request({
    url: "/lebo-member/web/partner/manage/export",
    method: "get",
    params,
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/octet-stream"
    }
  });
}
/** 删除合伙人接口 */
export const deletePartner = (id) => {
  return request({
    url: "/lebo-member/web/partner/manage/remove",
    method: "post",
    params: {
      id
    }
  });
}
